<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @openAddDialog="openAddDialog"
      @reload="() => $refs.tableHeader.query()"
      @batchDel="submitDel"
      @openEditImageDialog="openEditImageDialog"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openAddDialog="openAddDialog"
        @query="getData"
        @batchDel="batchDel"
      />
    </Main>
    <GoodsDetailDialog
      v-if="goodsDetailDialogParams.visible"
      :orderCode="orderCode"
      :disabled="goodsDetailDialogParams.disabled"
      :visible="goodsDetailDialogParams.visible"
      :title="goodsDetailDialogParams.title"
      :types="goodsDetailDialogParams.types"
      :orderGoodsCode="goodsDetailDialogParams.code"
      @reload="() => $refs.tableHeader.query()"
      @close="() => (goodsDetailDialogParams.visible = false)"
      ref="goodsDetailDialog"
    />
    <GoodsAddDialog
      v-if="goodAddDialogParams.visible"
      :orderCode="orderCode"
      :disabled="goodAddDialogParams.disabled"
      :visible="goodAddDialogParams.visible"
      :title="goodAddDialogParams.title"
      :types="goodAddDialogParams.types"
      :orderGoodsCode="goodAddDialogParams.code"
      @reload="() => $refs.tableHeader.query()"
      @close="() => (goodAddDialogParams.visible = false)"
    />
    <GoodsImagesDialog
      :visible.sync="goodsImagesDialogOptions.visible"
      :orderGoodsCode="goodsImagesDialogOptions.code"
      :title="'编辑订单产品图片信息'"
      @reload="() => $refs.tableHeader.query()"
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header'
import GoodsDetailDialog from '../goods-detail/dialog.vue'
import GoodsAddDialog from '../goods-detail/add-dialog.vue'
import GoodsImagesDialog from '../goods-images'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {
    Main,
    Header,
    GoodsDetailDialog,
    GoodsAddDialog,
    GoodsImagesDialog,
  },
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      goodsDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
        types: '',
      },
      goodAddDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
        types: '',
      },
      goodsImagesDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData(this.orderCode)
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .orderGoodsListApi({ orderCode: this.orderCode, ...form })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.$emit('reloadOrderInfo')
        })
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    async submitDel(listCode) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .orderGoodsDelApi({ listCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$refs.tableHeader.query()
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add: this.$l('goods_dialog_title_add_info') || '添加订单产品信息',
        edit: this.$l('goods_dialog_title_edit_info') || '编辑订单产品信息',
        detail: this.$l('goods_dialog_title_detail_info') || '订单产品信息详情',
        copy: this.$l('goods_dialog_title_copy_info') || '订单产品复制',
      }
      this.goodsDetailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
        types: type,
      }
    },
    openAddDialog({ type, code = '' }) {
      const types = {
        add: this.$l('goods_dialog_title_add_info') || '添加订单产品信息',
        copy: this.$l('goods_dialog_title_copy_info') || '订单产品复制',
      }
      this.goodAddDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
        types: type,
      }
    },
    openEditImageDialog({ orderGoodsCode }) {
      this.goodsImagesDialogOptions = {
        visible: true,
        code: orderGoodsCode,
      }
    },
  },
}
</script>
